module.exports = __webpack_public_path__ + "img/friend-1.b62554c2.png";